// extracted by mini-css-extract-plugin
module.exports = {"subNavItemWrapper":"StandardSubNavItem_subNavItemWrapper__T7eL_","logoImgWrapper":"StandardSubNavItem_logoImgWrapper__QKqU_","logoImage":"StandardSubNavItem_logoImage__sQqaf"};